<button
	(click)="optionClick.emit(item)"
	class="w-full h-32 flex items-center justify-center px-4 text-sm bg-almost-white border-light-grey rounded-[7px] border-1/2 text-almost-black active:bg-light-grey active:border-light-grey hover:bg-white hover:outline hover:outline-3/2 ">
	<img *ngIf="iconUrl" class="max-h-6" [src]="iconUrl" [alt]="iconAlt" />
	<span *ngIf="!iconUrl" class="w-24 overflow-auto font-medium text-center whitespace-normal text-almost-black">{{iconAlt}}</span>
</button>
